import { Theme } from "../../../../components/constants";

export default {
  columnHeader: {
    borderBottom:' 1px solid rgb(91, 98, 104)',
    display: 'flex',
    padding: '20px 5px',
    gap: '20px', 
    marginBottom: '30px',
  },
  column: {
      paddingLeft: '20px',
      display: 'flex',
      flexDirection: 'column', 
      flex: 1,
  },
  columnBody: {
    paddingLeft: '10px'
  },
  checkBox: {
    display: 'flex', 
    gap: '20px',
    marginTop: '10px',
    marginBottom: '10px'
  },
  fullWidth: {
    width:'100%'
  },
  text: { 
    fontSize: "16px",
    color: Theme.TEXT_PRIMARY_BLACK, 
    whiteSpace: 'pre' 
  }
}